import React from 'react';
import classnames from 'classnames/bind';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { S2STestLinkGenerator } from '../S22GenerateTestLink/S2STestLinkGenerator';
import styles from './serverEvents.module.scss';

const classNameBuilder = classnames.bind(styles);

export const ServerEvents = () => {
    return (
        <div className={classNameBuilder('server-events-container')}>
            <div className={classNameBuilder('how-it-works-section')}>
                <FormattedMessage
                    id="pixel.tester.website.instructions.title"
                    defaultMessage="How it works"
                    className={classNameBuilder('section-title')}
                />
                <ol className={classNameBuilder('server-events-list')}>
                    <li className={classNameBuilder('server-events-list-item')}>
                        <FormattedMessage
                            id="pixel.tester.server.events.step.1.text"
                            defaultMessage="<b>Complete Server Setup:</b> For a detailed step-by-step guide check our <a>Dev Center</a>"
                        />
                    </li>
                    <li className={classNameBuilder('server-events-list-item')}>
                        <FormattedMessage
                            id="pixel.tester.server.events.step.2.text"
                            defaultMessage="<b>Select Campaign:</b> Select the campaign that you would like to test."
                        />
                    </li>
                    <li className={classNameBuilder('server-events-list-item')}>
                        <FormattedMessage
                            id="pixel.tester.server.events.step.3.text"
                            defaultMessage="<b>Scan the QR Code:</b> Use your mobile device to scan the QR code. This allows you to interact with your website and trigger the embedded events."
                        />
                    </li>
                    <li className={classNameBuilder('server-events-list-item')}>
                        <FormattedMessage
                            id="pixel.tester.server.events.step.4.text"
                            defaultMessage="<b>View the Events:</b> Once the events are successfully received, they will appear in the panel."
                        />
                    </li>
                </ol>
            </div>

            <S2STestLinkGenerator />
        </div>
    );
};
